import React from "react";
import MUIDataTable from "mui-datatables";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../assets/Table/TableTheme";
import createOptions from "../../assets/Table/TableOption_Print";
import { ROWS_PER_PAGE_OPTIONS, DEFAULT_ROWS_PER_PAGE } from "../../assets/Table/TableConfig";

function TableWidget(props) {
  const {
    title,
    data,
    columns,
    totalCount = 0,
    page = 0,
    rowsPerPage = DEFAULT_ROWS_PER_PAGE,
    onPageChange,
    onRowsPerPageChange,
    onSearchChange,
    serverSide = true,
    rowsPerPageOptions = ROWS_PER_PAGE_OPTIONS,

    searchColumns,
    setSearchColumns,
  } = props;

  const count = serverSide ? totalCount : (data || []).length;
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
  const safePage = Math.min(Math.max(0, page), lastPage);

  return (
    <ThemeProvider theme={theme}>
      <MUIDataTable
        title={title}
        data={data}
        columns={columns}
        options={{
          ...createOptions(title, columns, data, { searchColumns, setSearchColumns }),
          serverSide,
          count,
          page: safePage,
          rowsPerPage,
          rowsPerPageOptions,
          jumpToPage: true,
          search: true,
          onTableChange: (action, tableState) => {
            if (action === "changePage") {
              onPageChange && onPageChange(tableState.page);
            }
            if (action === "changeRowsPerPage") {
              onRowsPerPageChange && onRowsPerPageChange(tableState.rowsPerPage);
              onPageChange && onPageChange(0);
            }
            if (action === "search") {
              onSearchChange && onSearchChange(tableState.searchText || "");
            }
          },
        }}
      />
    </ThemeProvider>
  );
}

export default TableWidget;
